import { useTranslation } from "react-i18next";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Stack, Typography } from "@mui/material";

import { AlertPanelBasic } from "../../../../../../alert-panel/AlertPanelBasic";
import { ExternalUrl } from "../../../../../../constants/externalUrls";
import { ExternalLink } from "../../../../../../external-link/ExternalLink";
import { AccordionKeys } from "../../../../../../utils/accordion-keys/AccordionKeys";

export function RelativesNoticeBox() {
  const { t } = useTranslation();
  const base = "clients.client.debtSettlement.assetInventory.dependants";

  return (
    <AlertPanelBasic
      severity="warning"
      title={t(`${base}.introTitle`)}
      icon={<InfoOutlinedIcon fontSize="small" />}
      storageKey={AccordionKeys.notice.relatives}
    >
      <Stack gap={0.5} alignItems="flex-start">
        <Typography variant="body2">{t(`${base}.introHelpTextLead`)}</Typography>
        <Box component="ul" sx={{ m: 0, pl: 3 }}>
          <Typography component="li" variant="body2">
            {t(`${base}.introHelpItemEntitled`)}
          </Typography>
          <Typography component="li" variant="body2">
            {t(`${base}.introHelpItemHousehold`)}
          </Typography>
        </Box>
        <Typography variant="body2">{t(`${base}.introExplanation`)}</Typography>
        <Typography variant="body2">
          {t(`${base}.introMoreInfoText`)}{" "}
          <ExternalLink href={ExternalUrl.LexikonUnterhalt} variant="body2">
            {t(`${base}.introMoreInfoLink`)}
          </ExternalLink>
        </Typography>
      </Stack>
    </AlertPanelBasic>
  );
}
